import React, { useEffect } from 'react';
import Label from '../components/ui/Label';
import Input from '../components/ui/Input';
import { useDispatch, useSelector } from 'react-redux';
import { clearLoginCredential, selectLoginGuestName, selectLoginGuestPin, setCredentials, setLoginCredential } from '../features/auth/authSlice';
import CBLogoLogIn from '../assets/images/capital brew logo.png';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { showToast } from '../toastify/Toast';
import { handleApiError } from '../utils/handleApiError';
import { updateCBrew } from '../utils/updateCpBrewLocal';
import { UserCredential } from '../types/response';
import Loading from '../components/ui/Loading';
import { setTypeModal } from '../features/modal/modalSlice';
import { useMutationData } from '../hooks/api/useMutationData';
import { GUEST_LOGIN_TIME } from '../utils/env';

export default function Login() {
    // Marco0d10.
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const guestName = useSelector(selectLoginGuestName)
    const clientPin = useSelector(selectLoginGuestPin)
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");
    const { userGuestLogin, isLoadingUserGuestLogin } = useMutationData()

    useEffect(() => {
        const tokenFromUrl = searchParams.get("token");
        if(tokenFromUrl){
            updateCBrew({
                token: tokenFromUrl
            });
        }
    }, [searchParams])

    const isDisableBtn = guestName === '' || guestName.length < 3;

    const handleSubmitGuest = async (e: React.FormEvent) => {
        e.preventDefault()
        
        const now = new Date();
        const currentMinutes = now.getHours() * 60 + now.getMinutes();

        // const TEN_AM = 10 * 60;      // 10:00 AM
        // const TEN_PM = 22 * 60;      // 10:00 PM
        // const MIDNIGHT = 0;          // 12:00 AM

        // 10:00 PM - 11:59 PM
        if (currentMinutes >= GUEST_LOGIN_TIME.TEN_PM) {
            showToast("Oops! You’re too early for tomorrow!", "error");
            return;
        }

        // 12:00 AM - 9:59 AM
        if (currentMinutes >= GUEST_LOGIN_TIME.MIDNIGHT && currentMinutes < GUEST_LOGIN_TIME.TEN_AM) {
            showToast("Oops! You’re a bit early!", "error");
            return;
        }

        if(!guestName){
            showToast('Please enter guest name', 'error');
            return
        }
        if (token == null || token === '' || token === undefined) {
            showToast('Invalid url. Please scan again the qr code.', 'error');
            return;
        }

        try {
            const body = { 
                token, 
                userName: guestName, 
                pin: clientPin 
            }
            const response = await userGuestLogin(body).unwrap()
            const credential: UserCredential = {
                isNewUsername: response.isNewUsername,
                accessToken: response.accessToken,
                refreshToken: response.refreshToken,
                staff: {
                    staffID: null,
                    firstName: '',
                    middleInitial: '',
                    lastName: '',
                    email: '',
                    phone: null,
                    status: '',
                    roleId: null,
                    statusId: null,

                    role: response.staff.role,
                    sessionId: response.staff.sessionId,
                    clientID: response.staff.clientID,
                    userName: response.staff.userName,
                    generatedUsername: response.staff.generatedUserName,
                    deceasedName: response.staff.deceasedName,
                    token: response.staff.token,
                }
            };
            dispatch(setCredentials(credential));
            updateCBrew({ token: token });
            dispatch(clearLoginCredential({type: 'guest'}))
            if(response.isNewUsername === true){
                dispatch(setTypeModal('isNewGuest'))
            }
            navigate('/')
        } catch (error: any) {
            // console.log("errorrrr: ", error)
            if(!error.response){
                handleApiError(error, "Server is not reachable. Please try again later.");
            } else {
                handleApiError(error, "Login failed. Please try again.");
            }
        }
    }

    return (
        <div className='min-h-screen flex items-center justify-center bg-gradient-to-br from-orange-50 via-white to-orange-50 px-4'>
            <div className='container flex flex-col items-center justify-center'>
                <div className='max-w-md w-full space-y-4'>
                    <div className='text-center'>
                        <img 
                            src={CBLogoLogIn}
                            alt="Capital Brew Logo" 
                            className="mx-auto w-[300px] h-[120px] object-contain md:w-[380px] mdLh-[200px]"
                        />
                        <div className="text-center">
                            <div className="inline-flex items-center gap-3 text-sm font-medium text-gray-700">
                                <span className="">Cafe hours</span>
                                <span className="text-gray-300">|</span>
                                <span className="text-gray-600 font-semibold">10:00 AM</span>
                                <span className="text-gray-300">-</span>
                                <span className="text-gray-600 font-semibold">9:30 PM</span>
                            </div>
                        </div>
                    </div>
                    <div className='bg-white p-8 rounded-2xl shadow-lg space-y-6'>

                        <div className="text-center ">
                            <h2 className="text-xl font-semibold text-gray-800">
                                Let’s get you signed in
                            </h2>
                            <p className="text-sm text-gray-600 mt-1">
                                Fresh coffee and warm bread, just a tap away.
                            </p>
                        </div>

                        {/* <div className="text-center">
                            <div className="inline-flex items-center gap-3 text-sm font-medium text-gray-700">
                                <span className="">Cafe hours</span>
                                <span className="text-gray-300">|</span>
                                <span className="text-gray-600 font-semibold">10:00 AM</span>
                                <span className="text-gray-300">-</span>
                                <span className="text-gray-600 font-semibold">9:30 PM</span>
                            </div>
                        </div> */}

                        <form 
                            className='space-y-4'
                        >
                            <div>
                                <Label label={'Guest Name *'}/>
                                <Input
                                    type={'text'}
                                    value={guestName}
                                    onChange={(e) => dispatch(setLoginCredential({ stateType: 'guest', type: 'userName', value: e.target.value }))}
                                    required
                                    disabled={isLoadingUserGuestLogin}
                                />
                                
                            </div>
                            <div>
                                <Label label={'PIN'} subLabel='(optional)'/>
                                <Input
                                    type={'number'}
                                    value={clientPin}
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/\D/g, '');
                                        if (value.length <= 6) {
                                            dispatch(setLoginCredential({ stateType: 'guest', type: 'pin', value }))
                                        }
                                    }}
                                    required
                                    maxLength={6}
                                    disabled={isLoadingUserGuestLogin}
                                />
                            </div>
                            <button
                                type="submit"
                                onClick={handleSubmitGuest}
                                disabled={isLoadingUserGuestLogin || isDisableBtn}
                                className={`${isLoadingUserGuestLogin || isDisableBtn ? 'bg-gray-200 text-black cursor-not-allowed' : 'bg-cbColor text-white'} inline-flex w-full items-center justify-center rounded p-2 text-sm font-medium`}
                            >
                                {isLoadingUserGuestLogin ? (
                                    <Loading setH={'h-[20px]'} message={'Signing In...'}/>
                                ) : ('Sign In')}
                            </button>
                        </form>
                    </div>
                </div>
                <p className='text-center text-sm pt-[30px]'>Copyright © {new Date().getFullYear()} PhilLife. All Rights Reserved</p>
            </div>
        </div>
    )
}